import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function requiredWhen(predicate: () => boolean): ValidatorFn {
    return (ctrl: AbstractControl): ValidationErrors | null =>
        typeof predicate === 'function' && predicate() ? Validators.required(ctrl) : null;
}
